$(function() {
  $('.slider-stack .next').click(function() {
    let $parent = $(this).parents('.slider-stack')
    let totalItems = parseInt($parent.attr('data-items-amount'))
    reindexItems('next', $parent.find('.stack-item'), totalItems)
  })

  $('.slider-stack .prev').click(function() {
    let $parent = $(this).parents('.slider-stack')
    let totalItems = parseInt($parent.attr('data-items-amount'))
    reindexItems('prev', $parent.find('.stack-item'), totalItems)
  })

  $('body').on('click', '.stack-item:not([data-position="1"])', function() {
    let thisEl = $(this)
    let elements = thisEl.parents('.slider-stack').find('.stack-item')
    let currentPos = parseInt(thisEl.attr('data-position'))

    $.each(elements, function(index, item) {
      let el = $(item)
      let pos = parseInt(el.attr('data-position'))

      if (pos === 1) {
        el.attr('data-position', currentPos)
        el.attr('data-index', currentPos)
        thisEl.attr('data-position', pos)
        thisEl.attr('data-index', pos)
      }
    })
  })
})

function reindexItems(move, elements, totalItems) {
  $.each(elements, function(index, item) {
    let el = $(item)
    let pos = parseInt(el.attr('data-position'))

    if (move === 'next') pos--

    if (move === 'prev') pos++

    if (pos < 1) pos = totalItems

    if (pos > totalItems) pos = 1

    el.attr('data-position', pos)

    if (move === 'next' && pos === totalItems) {
      setTimeout(function() {
        el.attr('data-index', pos)
      }, 400)
    } else {
      el.attr('data-index', pos)
    }
  })
}



// WEBPACK FOOTER //
// ./scripts/components/slider-stack.js